import React, {Component} from 'react';
import {connect} from 'react-redux';
import NewUserForm from '../components/newUserForm';
import {
  changeNewUserNewPasswordForm,
  changeNewUserProperties,
  changeNewUserStoreSettings,
  clearNewUser, closeChangePasswordModal, closeDeleteUserModal,
  deleteAragUser,
  handleSubCasesPerCaseType, openChangePasswordModal, openDeleteUserModal,
  requestEditUser,
  requestNewUser,
  resetAragUserPassword
} from "../actions/newUser";
import { push,goBack } from 'connected-react-router'
import {requestPremiumSettingsDamages} from "../actions/premiumSettings";
import {getCaseTypes} from "../actions/caseTypes";
import _ from 'lodash';
import {isAdminUser, isEmail} from "../helpers/functions";
import {getAragUserById, getUserGroups, getUserLevels} from "../actions/usersList";
import {unlockAragUser} from "../actions/user";

class NewUserFormHOC extends Component {

    componentDidMount(){
        if(isAdminUser(this.props.userRoles)){
            this.props.requestPremiumSettingsDamages();
            this.props.getCaseTypes();
            this.props.getUserLevels();
            this.props.getUserGroups();
        }
        if(this.props.locationPathName.includes('/edit-user/') ){
            this.props.getAragUserById({aragUserId: _.last(this.props.locationPathName.split('/'))});
        }
        if(this.props.locationPathName.includes('/manage-user-account')){
            this.props.getAragUserById({aragUserId: this.props.userId});
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.props.newUser.deletingAragUser && !nextProps.newUser.deletingAragUser &&
            !nextProps.newUser.deleteAragUserResponseMessage) {
            this.props.push('/users')
        }
    }

    _handleTextInputChange = (evt) => {
        this.props.newUserProperties(evt.target.name, evt.target.value);
    };

    _handleCheckboxChange = (evt) => {
        this.props.newUserProperties(evt.target.name, evt.target.checked)
    };

    _validateForm = () => {
        if (!isEmail(this.props.newUser.newUserFormData.email)) {
            this.props.newUserProperties('badResponse', 'Email address is not valid.');
            return  false;
        }
        return true
    };

    handleSubmit = (evt) => {
        evt.preventDefault();
        let isValid = this._validateForm();
        if (!isValid) return false;
            this.props.newUser.isNew ?
                this.props.addNewUser(this._getSendBodyDto())
                : this.props.patchUser(this._getSendBodyDto());

    };

    _getSendBodyDto = () => {
        let caseTypeDtos = [];
        _.forEach(this.props.newUser.newUserFormData.caseTypes, caseType => {
            caseTypeDtos.push({
                id: caseType.id,
                subCaseTypes: _.filter(caseType.subCaseTypes, s => {return _.has(this.props.newUser.newUserFormData.subCases, s.id)})
            });
        });
        return {
            ...this.props.newUser.newUserFormData,
            damageDtos: _.map(this.props.newUser.newUserFormData.damages, i => ({id: i.id})),
            CaseTypeDtos: caseTypeDtos,
            LevelMachineName: this.props.newUser.newUserFormData.level,
            roles: [this.props.newUser.newUserFormData.group]
        }
    };

    _getDamageBandsOptions = () => {
        return this.props.damageBands.map(band => ({
                value: band,
                name: band.range,
                key: band.id
            }))
    };

    _getCaseTypesOptions = () => {
        return this.props.caseTypes.map(caseTpe => ({
            value: caseTpe,
            name: caseTpe.name,
            key: caseTpe.id
        }))
    };

    _handleSubCasesPerCaseType = (name, value) => {
        this.props.newUserProperties(name,value);
    };

    _handleCaseTypesChange = (name, value) => {
        this.props.newUserProperties(name,value);
        //filter sub cases
        let validSubCasesTypes = [];
        _.forEach(value, caseType => {
            _.forEach(caseType.subCaseTypes, sub => {
                validSubCasesTypes.push(sub.id.toString())
            })
        });
        let subCases = _.pickBy(this.props.newUser.newUserFormData.subCases, (item, key) => {
            return _.includes(validSubCasesTypes, key.toString())
        });
        this.props.newUserProperties('subCases', subCases)
    };

    _handleDamagesSelect = (name, value) => {
        this.props.newUserProperties(name,value);
    };

    _getLevelOptions = () => {
        let o = this.props.userLevels.map(i => ({key: i.machineName, value: i.name}));
        o.unshift(({key:'', value: ''}));
        return o;
    };

    _getGroupOptions = () => {
        let o = this.props.userGroups.map(g => ({key: g.roleName, value: g.roleName}));
        o.unshift(({key:'', value: ''}));
        return o;
    };

    _getSubCasesOptions = () => {
        let o = [];
        _.forEach(this.props.newUser.newUserFormData.caseTypes, c => {
           _.forEach(c.subCaseTypes,s => {
               o.push({key: s.id, name: s.name, value: s})
           })
        });
        return o;
    };

    _changePassword = (evt) => {
        evt.preventDefault();
        if(this.props.newUser.changePasswordForm.newPassword !== this.props.newUser.changePasswordForm.reNewPassword){
            this.props.newUserProperties('badResponse', 'Passwords does not match.');
            this.props.changeNewUserStoreSettings({
                key: 'changePasswordModalOpen',
                value: false});
            return false;
        }
        this.props.patchUser({
            id: this.props.newUser.newUserFormData.id,
            password: this.props.newUser.changePasswordForm.password,
            newPassword: this.props.newUser.changePasswordForm.newPassword,
            reNewPassword: this.props.newUser.changePasswordForm.reNewPassword,
        });
    };

    _deleteUser = () => {

    }

    onUnlockUser = () => {
        this.props.unlockAragUser({
            aragUserId: this.props.newUser.newUserFormData.id
        })
    };


    render() {
        return (
            <NewUserForm
                onUnlockUser={this.onUnlockUser}
                changeNewUserNewPasswordForm={this.props.changeNewUserNewPasswordForm}
                _changePassword={this._changePassword}
                changeNewUserStoreSettings={this.props.changeNewUserStoreSettings}
                openChangePasswordModal={this.props.openChangePasswordModal}
                closeChangePasswordModal={this.props.closeChangePasswordModal}
                userRoles={this.props.userRoles}
                deleteAragUser={this.props.deleteAragUser}
                resetAragUserPassword={this.props.resetAragUserPassword}
                fetchingAragUserById={this.props.fetchingAragUserById}
                subCasesOptions={this._getSubCasesOptions()}
                _handleTextInputChange={this._handleTextInputChange}
                levelOptions={this._getLevelOptions()}
                groupOptions={this._getGroupOptions()}
                _handleDamagesSelect={this._handleDamagesSelect }
                _handleCaseTypesChange={this._handleCaseTypesChange}
                _handleSubCasesPerCaseType={this._handleSubCasesPerCaseType}
                damageBandsOptions={this._getDamageBandsOptions()}
                caseTypesOptions={this._getCaseTypesOptions()}
                _handleCheckboxChange={this._handleCheckboxChange}
                handleSubmit={this.handleSubmit}
                user={this.props.user}
                newUser={this.props.newUser}
                addNewUser={this.props.addNewUser}
                handleNewUser={this.props.newUserProperties}
                clearNewUser={this.props.clearNewUser}
                patchUser={this.props.patchUser}
                goBack={this.props.goBack}
                openDeleteUserModal={this.props.openDeleteUserModal}
                closeDeleteUserModal={this.props.closeDeleteUserModal}
            />
        )
    }

}

const mapStateToProps = (state) => {
    return {
        fetchingAragUserById: state.usersList.fetchingUserById,
        locationPathName: state.router.location.pathname,
        newUser: state.newUser,
        caseTypes: state.caseTypes.cases,
        subCaseTypes: state.caseTypes.subCases,
        damageBands: state.damages.damages,
        userLevels: state.usersList.userLevels,
        userGroups: state.usersList.userGroups,
        userRoles: state.user.loggedInUser.roles,
        userId: state.user.loggedInUser.id
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearNewUser: () => {
            dispatch(clearNewUser())
        },
        newUserProperties: (property, value) => {
            dispatch(changeNewUserProperties(property, value))
        },
        addNewUser: (newUser, token) => {
            dispatch(requestNewUser(newUser, token))
        },
        patchUser: (user) => {
            dispatch(requestEditUser(user))
        },
        goBack: () => {
            dispatch(goBack())
        },
        requestPremiumSettingsDamages: () => {
            dispatch(requestPremiumSettingsDamages())
        },
        getCaseTypes: () => {
            dispatch(getCaseTypes())
        },
        handleSubCasesPerCaseType: (payload) => {
            dispatch(handleSubCasesPerCaseType(payload))
        },
        getUserLevels: () => {
            dispatch(getUserLevels())
        },
        getUserGroups: () => {
            dispatch(getUserGroups())
        },
        getAragUserById: (payload) => {
            dispatch(getAragUserById(payload))
        },
        resetAragUserPassword: (payload) => {
            dispatch(resetAragUserPassword(payload))
        },
        deleteAragUser: (payload) => {
            dispatch(deleteAragUser(payload))
        },
        push: (url) => {
            dispatch(push(url))
        },
        changeNewUserStoreSettings: (payload) => {
            dispatch(changeNewUserStoreSettings(payload))
        },
        openChangePasswordModal: (payload) => {
            dispatch(openChangePasswordModal(payload))
        },
        closeChangePasswordModal: (payload) => {
            dispatch(closeChangePasswordModal(payload))
        },
        openDeleteUserModal: (payload) => {
            dispatch(openDeleteUserModal(payload))
        },
        closeDeleteUserModal: (payload) => {
            dispatch(closeDeleteUserModal(payload))
        },
        changeNewUserNewPasswordForm: (payload) => {
            dispatch(changeNewUserNewPasswordForm(payload))
        },
        unlockAragUser: (payload) => {
            dispatch(unlockAragUser(payload))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NewUserFormHOC);